import isMobile from 'is-mobile';
import { add, listen, qs, remove } from '@fluorescent/dom';
import { get, set } from '@fluorescent/storage';
import { createFocusTrap } from 'focus-trap';

import { section } from '@/neon';

const storage = {
  get: () => get('exit_intent'),
  set: val => set('exit_intent', val),
};
let focusTrap;

section('popup', {
  onLoad() {
    const closeBtn = qs('[data-close]', this.container);
    const overlay = qs('[data-overlay]', this.container);
    const popup = qs('.popup__bar', this.container);

    focusTrap = createFocusTrap(popup,{ allowOutsideClick: true });

    this.escPress = listen(this.container, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) this.close();
    }),

    this.closeClick = listen([closeBtn, overlay], 'click', e => {
      e.preventDefault();
      this.close();
    });
    this.bodyLeave = () => {};

    const { timeout } = this.container.dataset;

    const mouseleave = e => {
      if (!e.relatedTarget && !e.toElement) {
        this.open();
        this.bodyLeave();
      }
    };

    if (!storage.get() && isMobile()) {
      setTimeout(() => this.open(), parseInt(timeout));
    } else if (!storage.get()) {
      this.bodyLeave = listen(document.body, 'mouseout', mouseleave);
    }
  },

  open() {
    add(this.container, 'visible');
    focusTrap.activate();
  },

  close() {
    focusTrap.deactivate();
    storage.set(true);
    remove(this.container, 'visible');
  },

  onSelect() {
    this.open();
  },

  onDeselect() {
    this.close();
  },

  onUnload() {
    this.closeClick();
    this.bodyLeave();
    this.escPress()
  },
});
